<template>
<div>
  <v-navigation-drawer
    v-model="drawer"
    absolute
    temporary
    disable-route-watcher
    right
    class="filters-nav"
  >
    <v-list class="filters">
      <v-subheader>
        <v-layout row>
          <v-flex xs6>
            <label>Filtros</label>
          </v-flex>
          <v-flex xs6 class="text-xs-right">
            <a @click="resetFilters" v-if="activeFiltersCount">Borrar todo</a>
          </v-flex>
        </v-layout>
      </v-subheader>
      <v-list-group class="active">
        <v-list-tile slot="activator">
          <v-list-tile-content>
            <v-list-tile-title
              v-bind:class="{'': isSomeFilterActive(['start__gte', 'end__lte'])}"
              >
              Fecha comienzo/fin
            </v-list-tile-title>
            <v-list-tile-sub-title v-if="isSomeFilterActive(['start__gte', 'end__lte'])">
              {{ activeFilters.start__gte }} <label v-if="activeFilters.start__gte && activeFilters.end__lte">/</label> {{ activeFilters.end__lte }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
         <v-menu
          ref="start__gte"
          :close-on-content-click="false"
          v-model="start__gte"
          :nudge-right="5"
          full-width
          offset-y
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="activeFilters.start__gte"
            label="Fecha comienzo"
            prepend-icon="event"
            readonly
          ></v-text-field>
          <v-date-picker
            :first-day-of-week="1"
            locale="es-es"
            v-model="activeFilters.start__gte"
            no-title scrollable
            @input="start__gte = false"
            flat></v-date-picker>
        </v-menu>
         <v-menu
          ref="end__lte"
          :close-on-content-click="false"
          v-model="end__lte"
          :nudge-right="5"
          full-width
          offset-y
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="activeFilters.end__lte"
            label="Fecha fin"
            prepend-icon="event"
            readonly
          ></v-text-field>
          <v-date-picker
            :first-day-of-week="1"
            locale="es-es"
            v-model="activeFilters.end__lte"
            no-title scrollable
            @input="end__lte = false"></v-date-picker>
         </v-menu>
      </v-list-group>
      <v-list-group class="active">
        <v-list-tile slot="activator">
          <v-list-tile-content>
            <v-list-tile-title
              v-bind:class="{'': isFilterActive('status')}"
              >
              Estado
            </v-list-tile-title>
            <v-list-tile-sub-title v-if="isFilterActive('status')">
              {{ getSelectedStatus() }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
          <v-list-tile
            v-for="status in masters.statuses"
            :key="status.id">
            <v-list-tile-action class="checkbox-list">
              <v-checkbox
                v-model="activeFilters.status"
                :value="status.id">
              </v-checkbox>
            </v-list-tile-action>
            <v-list-tile-title>{{ status.name }}</v-list-tile-title>
          </v-list-tile>
      </v-list-group>
      <v-list-group class="active">
        <v-list-tile slot="activator">
          <v-list-tile-content>
            <v-list-tile-title
              v-bind:class="{'': isFilterActive('process_type')}"
              >
              Tipo de Proceso
            </v-list-tile-title>
            <v-list-tile-sub-title v-if="isFilterActive('process_type')">
              {{ selectedProcessType.name }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
          <v-radio-group
            v-model="activeFilters.process_type"
            :hide-details="true"
            @change="loadProcessTypeMaterials">
            <v-radio
              v-for="processType in masters.processTypes"
              :key="processType.id"
              :label="processType.name"
              :value="processType.id"
            ></v-radio>
          </v-radio-group>
      </v-list-group>
      <v-list-group class="active">
        <v-list-tile slot="activator">
          <v-list-tile-content>
            <v-list-tile-title
              v-bind:class="{'': isFilterActive('tags')}"
              >
              Etiquetas
            </v-list-tile-title>
            <v-list-tile-sub-title v-if="isFilterActive('tags')">
              {{ selectedTags.name }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
          <v-list-tile
            v-for="tag in masters.tags"
              :key="tag.id">
            <v-list-tile-action class="checkbox-list">
              <v-checkbox
                v-model="activeFilters.tags"
                :value="tag.id">
              </v-checkbox>
            </v-list-tile-action>
            <v-list-tile-title>{{ tag.name }}</v-list-tile-title>
          </v-list-tile>
      </v-list-group>
      <v-list-group :disabled="!isFilterActive('process_type')">
        <v-list-tile slot="activator">
          <v-list-tile-content>
            <v-list-tile-title
              v-bind:class="{'': isFilterActive('process_type')}"
              >
              Materiales
            </v-list-tile-title>
            <v-list-tile-sub-title v-if="isFilterActive('process_type')">
              {{ getSelectedMaterials() }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
          <v-list-tile
            v-for="material in masters.materials"
            :key="material.id"
            :dense="true">
            <v-list-tile-action class="checkbox-list">
              <v-checkbox
                v-model="activeFilters.material"
                :value="material.id">
              </v-checkbox>
            </v-list-tile-action>
            <v-list-tile-title class="caption">{{ material.name }}</v-list-tile-title>
          </v-list-tile>
      </v-list-group>
      <v-list-group class="active">
        <v-list-tile slot="activator">
          <v-list-tile-content>
            <v-list-tile-title
              v-bind:class="{'': isFilterActive('has_analysis')}"
              >
              Analísis
          </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
          <v-radio-group
            v-model="activeFilters.has_analysis"
            :hide-details="true"
            @change="loadProcessTypeMaterials">
            <v-radio
              :key="1"
              label="Sí"
              value="true"
            ></v-radio>
            <v-radio
              :key="2"
              label="No"
              value="false"
            ></v-radio>
          </v-radio-group>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
  <v-toolbar flat class="pa-3">
    <v-text-field
      label="Busca por código, observaciones, tipo, materia y etiquetas"
      append-icon="search"
      v-model="activeFilters.search"
      />
    <v-btn flat color="accent" @click.stop="drawer = !drawer">
      <v-badge color="primary" :value="activeFiltersCount">
        <span slot="badge">{{ activeFiltersCount }}</span>
        <span>Filtros</span>
      </v-badge>
    </v-btn>
  </v-toolbar>
  <data-table
    :pagination.sync="pagination"
    :total="totalResults"
    :items="processes"
    :headers="headers"
    :loading="loading"
    :row-action="toDetailRoute"
    @paginationUpdated=paginationUpdated
    :page="currentPage"
    >
    <template slot="row" slot-scope="row">
      <td>{{ row.item.code }}</td>
      <td>{{ row.item.process_type.name }}</td>
      <td>{{ row.item.material.name }}</td>
      <td>{{ row.item.status_display }}</td>
      <td>{{ row.item.start|format-date-time }}</td>
      <td>{{ row.item.end|format-date-time }}</td>
      <td class="text-xs-right">{{ row.item.total_minutes_lost }} m.</td>
      <td class="text-xs-right">{{ row.item.total_weight }} t.</td>
      <td class="text-xs-right">{{ hasAnalysis(row.item.analysis) }} </td>
      <td>{{ row.item.created|format-date-time }}</td>
      <td>{{ row.item.modified|format-date-time }}</td>
      <td>{{ row.item.tags.toString() }}</td>
    </template>
  </data-table>
  <v-dialog v-model="dialogs.newProcess" persistent max-width="640px">
    <v-btn v-show="!drawer" class="elevation-2" color="accent" top right fixed fab slot="activator"><v-icon>add</v-icon></v-btn>
    <process-form
      title="Nuevo proceso"
      :is-valid.sync="valid"
      :process.sync="newProcess"
      :show-cancel="true"
      :errors="fieldErrors"
      @cancel="dialogs.newProcess = false"
      @submit="submit"
      action-name="crear"
      :masters="masters"
      />
  </v-dialog>
</div>
</template>


<script>
import _ from 'lodash'

import api from '@/api/app'
import DataTable from '@/components/DataTable'
import formMixin from '@/mixins/formMixin'
import urlParamsMixin from '@/mixins/urlParamsMixin'
import mutationsMixin from '@/mixins/mutationsMixin'

import ProcessForm from '@/partials/ProcessForm'

export default {
  name: 'processList',
  components: {DataTable, ProcessForm},
  mixins: [formMixin, urlParamsMixin, mutationsMixin],
  mounted () {
    this.loading = true

    let p1 = api.getProcessTypes().then(response => {
      this.loadProcessTypeMaterials()
      this.masters.processTypes = response
    })

    let p2 = api.getProcessStatuses().then(response => {
      this.masters.statuses = response
    })

    let p3 = api.getTags().then(response => {
      this.masters.tags = response
    })

    Promise.all([p1, p2, p3]).then(() => {
      this.loading = false
    })
  },
  data () {
    return {
      drawer: false,
      dialogs: {},
      headers: [
        {
          text: 'Código',
          align: 'left',
          sortable: true,
          value: 'code'
        },
        {
          text: 'Tipo',
          align: 'left',
          sortable: true,
          value: 'process_type.name'
        },
        {
          text: 'Materia Prima',
          align: 'left',
          sortable: true,
          value: 'material.name'
        },
        {
          text: 'Estado',
          align: 'left',
          sortable: true,
          value: 'status'
        },
        {
          text: 'Comienzo',
          align: 'left',
          sortable: true,
          value: 'start'
        },
        {
          text: 'Fin',
          align: 'left',
          sortable: true,
          value: 'end'
        },
        {
          text: 'Total tiempo u.',
          align: 'right',
          sortable: true,
          value: 'total_minutes_lost'
        },
        {
          text: 'Peso total',
          align: 'right',
          sortable: true,
          value: 'total_weight'
        },
        {
          text: 'Analíticas',
          align: 'right',
          sortable: true,
          value: 'analisys'
        },
        {
          text: 'Creado',
          align: 'left',
          sortable: true,
          value: 'created'
        },
        {
          text: 'Modificado',
          align: 'left',
          sortable: true,
          value: 'modified'
        },
        {
          text: 'Etiquetas',
          align: 'left',
          sortable: true,
          value: 'tags'
        }
      ],
      processes: [],
      newProcess: {},
      selectedProcessType: {},
      selectedMaterials: [],
      selectedStatus: [],
      selectedTags: [],
      masters: {processTypes: [], materials: [], statuses: []},
      filters: ['material', 'process_type', 'status', 'start__gte', 'end__lte', 'has_analysis'],
      activeFilters: {
        status: [],
        material: [],
        tags: [],
        has_analysis: []
      },
      params: {
        status: [],
        material: [],
        page: null,
        page_size: null},
      pagination: {},
      currentPage: null,
      totalResults: 0,
      start__gte: false,
      end__lte: false
    }
  },
  computed: {
    activeFiltersCount () {
      let counter = 0
      this.filters.forEach(element => {
        if (this.isFilterActive(element)) {
          counter = counter + 1
        }
      })
      return counter
    }
  },
  methods: {
    setURLQueryParams () {
      Object.assign(this.params, this.activeFilters, this.pagination)
      Object.keys(this.params).forEach(key => {
        if (!this.params[key]) { delete this.params[key] }
      })
      this.$router.replace({ name: this.$route.name, query: this.params })
    },
    joinDateTime () {
      return this.$options.filters.joinDateTime
    },
    toDetailRoute (id) {
      this.$router.push({name: 'process-detail', params: {'id': id}})
    },
    onSubmit () {
      let submitData = {
        process_type: this.newProcess.process_type,
        material: this.newProcess.material,
        worker_schedule_hours: this.newProcess.worker_schedule_hours,
        break_time: this.newProcess.break_time,
        start: this.$options.filters.joinDateTime(this.newProcess.startDate, this.newProcess.startTime),
        end: this.$options.filters.joinDateTime(this.newProcess.endDate, this.newProcess.endTime),
        comments: this.newProcess.comments,
        tags: this.newProcess.tags
      }
      return api.createProcess(submitData)
    },
    onSuccess (response) {
      this.$router.push({name: 'process-detail', params: {'id': response.id}})
      this.success('Proceso creado con éxito')
    },
    loadProcessTypeMaterials () {
      this.activeFilters.material = []

      if (!this.activeFilters.process_type) {
        this.masters.materials = []
        return
      }

      return api.getProcessTypeRawMaterials(this.activeFilters.process_type).then(response => {
        this.masters.materials = response
        this.selectedProcessType = this.getProcessTypeById(this.activeFilters.process_type)
      })
    },
    getProcesses: _.debounce(function () {
      api.getProcesses(this.params).then(response => {
        this.processes = response.results
        this.totalResults = response.count
      })
    }, 400),
    resetFilters () {
      this.activeFilters = {
        material: [],
        status: [],
        process_type: null,
        start__gte: null,
        end__lte: null
      }
    },
    isSomeFilterActive (filtersNames) {
      let active = false
      filtersNames.forEach(element => {
        if (this.isFilterActive(element)) {
          active = true
        }
      })
      return active
    },
    isFilterActive (filterName) {
      if (Object.keys(this.activeFilters).indexOf(filterName) === -1) {
        return false
      }
      if (Array.isArray(this.activeFilters[filterName])) {
        return this.activeFilters[filterName].length > 0
      }
      return this.activeFilters[filterName]
    },
    getProcessTypeById (processTypeId) {
      return this.masters.processTypes.find(function (element) {
        return element.id === processTypeId
      })
    },
    getStatusById (statusId) {
      return this.masters.statuses.find(function (element) {
        return element.id === statusId
      })
    },
    getMaterialById (materialId) {
      return this.masters.materials.find(function (element) {
        return element.id === materialId
      })
    },
    getTagById (tagId) {
      return this.masters.tags.find(function (element) {
        return element.id === tagId
      })
    },
    getSelectedMaterials () {
      return this.selectedMaterials.map(function (e) {
        return e.name
      }).join(',')
    },
    getSelectedStatus () {
      return this.selectedStatus.map(function (e) {
        return e.name
      }).join(',')
    },
    updateSelectedMaterials () {
      this.selectedMaterials = []

      let self = this
      this.activeFilters.material.map(function (e) {
        self.selectedMaterials.push(self.getMaterialById(e))
      })
    },
    updateSelectedStatus () {
      this.selectedStatus = []

      let self = this
      this.activeFilters.status.map(function (e) {
        self.selectedStatus.push(self.getStatusById(e))
      })
    },
    updateSelectedTags () {
      this.selectedTags = []

      let self = this
      this.activeFilters.tags.map(function (e) {
        self.selectedTags.push(self.getTagById(e))
      })
    },
    paginationUpdated (pagination) {
      if (this.loading) {
        this.getUrlParams(this.filters, this.activeFilters)
      }
      this.pagination = pagination
      this.currentPage = this.pagination.page
      this.setURLQueryParams()
      this.getProcesses()
    },
    hasAnalysis (analysis) {
      if (!analysis.length) {
        return 'No'
      }

      return 'Si'
    }
  },
  watch: {
    activeFilters: {
      handler () {
        if (this.loading) { return }

        this.updateSelectedMaterials()
        this.updateSelectedStatus()
        this.updateSelectedTags()
        this.currentPage = 1
        this.setURLQueryParams()
        this.getProcesses()
      },
      deep: true
    },
    search (filter) {
      this.setURLQueryParams()
      this.getProcesses()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ProcessList.vue